import { render } from "./ResponsesTable.vue?vue&type=template&id=23a7c881"
import script from "./ResponsesTable.vue?vue&type=script&lang=js"
export * from "./ResponsesTable.vue?vue&type=script&lang=js"

import "./ResponsesTable.vue?vue&type=style&index=0&id=23a7c881&lang=scss"
script.render = render

export default script